var _excluded = ["icon", "sizeSpace", "emphasis", "text", "typography", "onClick", "iconColor", "hasTextToRight", "backgroundColor", "hasBorder", "borderColor", "borderRadius", "paddingSpace", "hasShadowOnHover", "hasDisabledTouchTargetSpace", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import OnColorContext from "../../../contexts/OnColorContext";
import PushOrg from "../../organisms/PushOrg";
import IconAtm from "../IconAtm";
import TextAtm from "../TextAtm";
import StyledIconButtonAtm from "./IconButtonAtm.styled";
export var defaultProps = {
  emphasis: "high",
  typography: "tiny2"
};
function IconButtonAtm(_ref) {
  var icon = _ref.icon,
    sizeSpace = _ref.sizeSpace,
    _ref$emphasis = _ref.emphasis,
    emphasis = _ref$emphasis === void 0 ? defaultProps.emphasis : _ref$emphasis,
    text = _ref.text,
    _ref$typography = _ref.typography,
    typography = _ref$typography === void 0 ? defaultProps.typography : _ref$typography,
    onClick = _ref.onClick,
    iconColor = _ref.iconColor,
    hasTextToRight = _ref.hasTextToRight,
    backgroundColor = _ref.backgroundColor,
    hasBorder = _ref.hasBorder,
    borderColor = _ref.borderColor,
    borderRadius = _ref.borderRadius,
    paddingSpace = _ref.paddingSpace,
    hasShadowOnHover = _ref.hasShadowOnHover,
    hasDisabledTouchTargetSpace = _ref.hasDisabledTouchTargetSpace,
    title = _ref.title,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var onColor = useContext(OnColorContext);
  return /*#__PURE__*/React.createElement(StyledIconButtonAtm, _extends({
    onClick: onClick,
    $onColor: onColor,
    $emphasis: emphasis,
    $hasText: !!text,
    $iconSize: sizeSpace,
    $hasTextToRight: hasTextToRight,
    $backgroundColor: backgroundColor,
    $hasBorder: hasBorder,
    $borderColor: borderColor,
    $borderRadius: borderRadius,
    $paddingSpace: paddingSpace,
    $hasShadowOnHover: hasShadowOnHover,
    $hasDisabledTouchTargetSpace: hasDisabledTouchTargetSpace,
    title: title,
    "aria-label": title
  }, restProps), /*#__PURE__*/React.createElement(IconAtm, {
    icon: icon,
    sizeSpace: sizeSpace,
    emphasis: emphasis,
    color: iconColor
  }), text ? /*#__PURE__*/React.createElement(PushOrg, {
    topSpace: hasTextToRight ? 0 : 1
  }, /*#__PURE__*/React.createElement(TextAtm, {
    typography: typography
  }, text)) : null);
}
export default IconButtonAtm;